module.exports = __webpack_public_path__ + "img/logoOhneSchrift.06575888.svg";